"use strict";

var _interopRequireDefault = require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
var _regenerator2 = _interopRequireDefault(require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("core-js/modules/es6.regexp.to-string");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _waves = _interopRequireDefault(require("@/directive/waves"));
var _vuex = require("vuex");
var _operation = require("@/api/operation");
var _statistics = require("@/api/statistics");
var _default = exports.default = {
  components: {
    Pagination: _Pagination.default
  },
  directives: {
    waves: _waves.default
  },
  filters: {},
  data: function data() {
    return {
      listLoading: false,
      branchList: [{
        label: '海外一部',
        value: 1
      }, {
        label: '海外二部',
        value: 2
      }, {
        label: '海外三部',
        value: 3
      }],
      channelList: [],
      list: [],
      total: 0,
      listQuery: {
        page: 1,
        size: 10,
        branch: '',
        startTime: '',
        endTime: '',
        channelArr: '',
        channel_no: '',
        type: 1
      },
      dialogVisible: false,
      xlsColumns: [{
        label: '日期',
        value: 'created_at'
      }, {
        label: '渠道号',
        value: 'channel_no'
      }, {
        label: '实充金额',
        value: 'user_recharge_amount'
      }, {
        label: '实结金额',
        value: 'actual_settlement_amount'
      }, {
        label: '充值总人数',
        value: 'recharge_all_user_count'
      }, {
        label: '新增用户数',
        value: 'new_user_count'
      }, {
        label: '新用户实充',
        value: 'new_user_recharge_amount'
      }, {
        label: '新用户实结',
        value: 'new_user_settle_amount'
      }, {
        label: '新用户付费人数',
        value: 'new_user_recharge_count'
      }, {
        label: '充值金币人数',
        value: 'recharge_gold_user_count'
      }, {
        label: '金币实充金额',
        value: 'user_recharge_gold'
      }, {
        label: '充值VIP人数',
        value: 'recharge_vip_user_count'
      }, {
        label: 'VIP实充金额',
        value: 'user_recharge_vip'
      }, {
        label: '新用户充值金币人数',
        value: 'new_user_recharge_gold_count'
      }, {
        label: '新用户金币实充',
        value: 'new_user_recharge_gold_amount'
      }, {
        label: '新用户充值VIP人数',
        value: 'new_user_recharge_vip_count'
      }, {
        label: '新用户VIP实充金额',
        value: 'new_user_recharge_vip_amount'
      }, {
        label: '赠送免费通话次数',
        value: 'give_free_video_count'
      }, {
        label: '使用免费通话人数',
        value: 'use_user_free_video_count'
      }, {
        label: '使用免费通话次数',
        value: 'use_free_video_count'
      }],
      columns: [],
      times: [],
      downTimes: [],
      startTime: '',
      endTime: '',
      checkAll: false,
      isIndeterminate: true
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['roles', 'name'])),
  watch: {
    times: function times(val) {
      this.listQuery.startTime = '';
      this.listQuery.endTime = '';
      if (val) {
        this.listQuery.startTime = val[0];
        this.listQuery.endTime = val[1];
      }
    }
  },
  mounted: function mounted() {
    this.getList();
  },
  created: function created() {
    this.columns = this.xlsColumns.map(function (item) {
      return item.value;
    });
    this.getChannelCodeList();
  },
  methods: {
    getList: function () {
      var _getList = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var _yield$channelList, code, data;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              this.listLoading = true;
              this.listQuery.channel_no = this.listQuery.channelArr.toString();
              _context.n = 1;
              return (0, _statistics.channelList)(this.listQuery);
            case 1:
              _yield$channelList = _context.v;
              code = _yield$channelList.code;
              data = _yield$channelList.data;
              this.listLoading = false;
              if (code === 0) {
                this.list = data.list;
                this.total = data.total;
              }
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function getList() {
        return _getList.apply(this, arguments);
      }
      return getList;
    }(),
    getChannelCodeList: function () {
      var _getChannelCodeList = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        var _yield$channelCodeLis, code, data;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              this.listLoading = true;
              _context2.n = 1;
              return (0, _operation.channelCodeList)({
                branch: this.listQuery.branch
              });
            case 1:
              _yield$channelCodeLis = _context2.v;
              code = _yield$channelCodeLis.code;
              data = _yield$channelCodeLis.data;
              this.listLoading = false;
              if (code === 0) {
                this.channelList = data;
              }
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function getChannelCodeList() {
        return _getChannelCodeList.apply(this, arguments);
      }
      return getChannelCodeList;
    }(),
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    userExport: function userExport() {
      this.dialogVisible = true;
    },
    userExportList: function userExportList() {
      this.listQuery.channel_no = this.listQuery.channelArr.toString();
      window.open("/api/xls/channelData/export?channel_no=".concat(this.listQuery.channel_no, "&columns=").concat(this.columns.toString(), "&startTime=").concat(this.listQuery.startTime, "&endTime=").concat(this.listQuery.endTime, "&roles=").concat(this.roles, "&username=").concat(this.name, "&type=1"));
    },
    handleCheckAllChange: function handleCheckAllChange(val) {
      this.columns = val ? this.xlsColumns.map(function (item) {
        return item.value;
      }) : [];
      this.isIndeterminate = false;
    },
    handleCheckedColumnChange: function handleCheckedColumnChange(value) {
      var checkedCount = value.length;
      this.checkAll = checkedCount === this.xlsColumns.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.xlsColumns.length;
    }
  }
};